<template>
  <PageView :main-title="$t('carte.title')" :no-sub-title-expected="true">
    <ContentView :wide-screen="true">
      <MapClusterComponent />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import MapClusterComponent from "@/views/maps/MapClusterComponent.vue"

export default defineComponent({
  name: "CartePage",
  components: {
    PageView,
    ContentView,
    MapClusterComponent,
  },
})
</script>
